export const ASSIGN_CONTENT_FEED_ACTIONS = {
	ASSIGN_CONTENT_FEED_AJAX: "ASSIGN_CONTENT_FEED_AJAX",
	ASSIGN_CONTENT_FEED_SUCCESS: "ASSIGN_CONTENT_FEED_SUCCESS",
	ASSIGN_CONTENT_FEED_ERROR: "ASSIGN_CONTENT_FEED_ERROR",
	FETCH_LIBRARY_CONTENT_FEEDS_AJAX: "FETCH_LIBRARY_CONTENT_FEEDS_AJAX",
	FETCH_LIBRARY_CONTENT_FEEDS_SUCCESS: "FETCH_LIBRARY_CONTENT_FEEDS_SUCCESS",
	FETCH_LIBRARY_CONTENT_FEEDS_ERROR: "FETCH_LIBRARY_CONTENT_FEEDS_ERROR",
	ASSIGN_EXISTING_CONTENT_FEED_AJAX: "ASSIGN_EXISTING_CONTENT_FEED_AJAX",
	ASSIGN_EXISTING_CONTENT_FEED_SUCCESS: "ASSIGN_EXISTING_CONTENT_FEED_SUCCESS",
	ASSIGN_EXISTING_CONTENT_FEED_ERROR: "ASSIGN_EXISTING_CONTENT_FEED_ERROR",
	ASSIGN_BLANK_CONTENT_FEED_AJAX: "ASSIGN_BLANK_CONTENT_FEED_AJAX",
	ASSIGN_BLANK_CONTENT_FEED_SUCCESS: "ASSIGN_BLANK_CONTENT_FEED_SUCCESS",
	ASSIGN_BLANK_CONTENT_FEED_ERROR: "ASSIGN_BLANK_CONTENT_FEED_ERROR",
};
